import { render, staticRenderFns } from "./EditDetailsModal.vue?vue&type=template&id=5242d7fe"
import script from "./EditDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports